<template>
  <div class="w-full flex flex-col lg:flex-row flex-wrap">
    <div class="w-full lg:w-3/6">
      <div class="m-4 widget shad rounded-lg">
        <div class="widget_title p-4 rounded-t-lg" :class="(dark) ? 'bg-widgetheaderDark text-white' : 'bg-widgetheaderLight'">
          <h2 class="text-xl">{{ $t('stats.fivedeaths') }}</h2>
        </div>
        <div class="widget-content h-512 bg-white rounded-b-lg" :style="(dark) ? 'background: #00232a' : 'background: white'">
          <highcharts class="rounded-b-lg" :options="deathsOptions" :updateArgs="updateArgs"></highcharts>
        </div>
      </div>
    </div>
    <div class="w-full lg:w-3/6">
      <div class="m-4 widget shad rounded-lg">
        <div class="widget_title p-4 rounded-t-lg" :class="(dark) ? 'bg-widgetheaderDark text-white' : 'bg-widgetheaderLight'">
          <h2 class="text-xl">{{ $t('stats.hundredcase') }}</h2>
        </div>
        <div class="widget-content h-512 bg-white rounded-b-lg" :style="(dark) ? 'background: #00232a' : 'background: white'">
          <highcharts class="rounded-b-lg" :options="confirmedOptions" :updateArgs="updateArgs"></highcharts>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name:"Stats",
  computed: {
    dark () {
      return this.$store.state.dark
    }
  },
  data () {
    return {
      updateArgs: [ true, true, { duration: 1000 } ],
      deathsOptions: {
        chart: {
          backgroundColor: '#FFF',
          height: 512,
          type: 'spline'
        },
        title: null,
        xAxis: {
          categories: [],
          labels : {
            style:{
              color: '#000000'
            }
          },
          title: {
            text: null
          },
          breaks: [{
            from: 0,
            to: 30,
            breakSize: 5
          }]
        },
        yAxis: {
          type: 'logarithmic',
          labels : {
            style:{
              color: '#000000'
            }
          },
          title: {
            text: this.$t('charts.nbrdeaths'),
            style:{
              color: '#000000'
            }
          }
        },
        legend:{
          itemHiddenStyle: {
            color: '#cccccc'
          },
          itemHoverStyle: {
            color: '#333333'
          },
          itemStyle: {
            color: '#000000',
            cursor: 'pointer',
            fontSize: '12px',
            fontWeight: 'bold',
            textOverflow: 'ellipsis'
          }
        },
        credits: {
          enabled: false
        },
        tooltip: {
          formatter: function () {
            return (this.y);
          }
        },
        series: [{
          name: this.$t('countries.maroc'),
          data: []
        }, {
          name: this.$t('countries.tunisie'),
          data: []
        }, {
          name: this.$t('countries.algerie'),
          data: []
        }, {
          name: this.$t('countries.egypte'),
          data: []
        }]
      },
      confirmedOptions: {
        chart: {
          backgroundColor: '#FFF',
          height: 512,
          type: 'spline'
        },
        title: null,
        xAxis: {
          categories: [],
          labels : {
            style:{
              color: '#000000'
            }
          },
          title: {
            text: null
          },
          breaks: [{
            from: 0,
            to: 30,
            breakSize: 5
          }]
        },
        yAxis: {
          type: 'logarithmic',
          labels : {
            style:{
              color: '#000000'
            }
          },
          title: {
            text: this.$t('charts.nbrcases'),
            style:{
              color: '#000000'
            }
          }
        },
        legend:{
          itemHiddenStyle: {
            color: '#cccccc'
          },
          itemHoverStyle: {
            color: '#333333'
          },
          itemStyle: {
            color: '#000000',
            cursor: 'pointer',
            fontSize: '12px',
            fontWeight: 'bold',
            textOverflow: 'ellipsis'
          }
        },
        credits: {
          enabled: false
        },
        tooltip: {
          formatter: function () {
            return (this.y);
          }
        },
        series: [{
          name: this.$t('countries.maroc'),
          data: []
        }, {
          name: this.$t('countries.tunisie'),
          data: []
        }, {
          name: this.$t('countries.algerie'),
          data: []
        }, {
          name: this.$t('countries.egypte'),
          data: []
        }]
      }
    }
  },
  methods: {
    async getDeathsData() {
      return await axios({ method: 'GET', url: 'https://raw.githubusercontent.com/afaddoul/covid19-maroc-data/master/confirmed-deaths-since-5th-death.json' })
      .then(resp => {
        resp.data.forEach(elem => {
          if (elem['Code'] == 'DZA')
            this.deathsOptions.series[2].data.push(elem[' (deaths)'])
          else if (elem['Code'] == 'EGY')
            this.deathsOptions.series[3].data.push(elem[' (deaths)'])
          else if (elem['Code'] == 'MAR')
            this.deathsOptions.series[0].data.push(elem[' (deaths)'])
          else if (elem['Code'] == 'TUN')
            this.deathsOptions.series[1].data.push(elem[' (deaths)'])
        });
      })
      .catch(err => {
        console.log(err)
      })
    },
    async getConfirmedData() {
      return await axios({ method: 'GET', url: 'https://raw.githubusercontent.com/afaddoul/covid19-maroc-data/master/confirmed-cases-since-100th-case.json' })
      .then(resp => {
        resp.data.forEach(elem => {
          if (elem['Code'] == 'DZA')
            this.confirmedOptions.series[2].data.push(elem[' (cases)'])
          else if (elem['Code'] == 'EGY')
            this.confirmedOptions.series[3].data.push(elem[' (cases)'])
          else if (elem['Code'] == 'MAR')
            this.confirmedOptions.series[0].data.push(elem[' (cases)'])
          else if (elem['Code'] == 'TUN')
            this.confirmedOptions.series[1].data.push(elem[' (cases)'])
        });
      })
      .catch(err => {
        console.log(err)
      })
    },
    initColors() {
      if (this.dark == true) {
        this.deathsOptions.chart.backgroundColor = '#00232a';
        this.deathsOptions.xAxis.labels.style.color = '#ffffff';
        this.deathsOptions.yAxis.labels.style.color = '#ffffff';
        this.deathsOptions.yAxis.title.style.color = '#ffffff';
        this.deathsOptions.legend.itemStyle.color = '#ffffff';
        this.deathsOptions.legend.itemHiddenStyle.color = '#000000';
        this.deathsOptions.legend.itemHoverStyle.color = '#dddddd';
        this.confirmedOptions.chart.backgroundColor = '#00232a';
        this.confirmedOptions.xAxis.labels.style.color = '#ffffff';
        this.confirmedOptions.yAxis.labels.style.color = '#ffffff';
        this.confirmedOptions.yAxis.title.style.color = '#ffffff';
        this.confirmedOptions.legend.itemStyle.color = '#ffffff';
        this.confirmedOptions.legend.itemHiddenStyle.color = '#000000';
        this.confirmedOptions.legend.itemHoverStyle.color = '#dddddd';
      }
      else {
        this.deathsOptions.chart.backgroundColor = '#ffffff';
        this.deathsOptions.xAxis.labels.style.color = '#000000';
        this.deathsOptions.yAxis.labels.style.color = '#000000';
        this.deathsOptions.yAxis.title.style.color = '#000000';
        this.deathsOptions.legend.itemStyle.color = '#000000';
        this.deathsOptions.legend.itemHiddenStyle.color = '#dddddd';
        this.deathsOptions.legend.itemHoverStyle.color = '#333333';
        this.confirmedOptions.chart.backgroundColor = '#ffffff';
        this.confirmedOptions.xAxis.labels.style.color = '#000000';
        this.confirmedOptions.yAxis.labels.style.color = '#000000';
        this.confirmedOptions.yAxis.title.style.color = '#000000';
        this.confirmedOptions.legend.itemStyle.color = '#000000';
        this.confirmedOptions.legend.itemHiddenStyle.color = '#dddddd';
        this.confirmedOptions.legend.itemHoverStyle.color = '#333333';
      }
    }
  },
  async created () {
    this.initColors()
    await this.getDeathsData()
    await this.getConfirmedData()
  },
  watch: {
    dark: function(newVal, oldVal) {
      if (newVal == true) {
        this.deathsOptions.chart.backgroundColor = '#00232a';
        this.deathsOptions.xAxis.labels.style.color = '#ffffff';
        this.deathsOptions.yAxis.labels.style.color = '#ffffff';
        this.deathsOptions.yAxis.title.style.color = '#ffffff';
        this.deathsOptions.legend.itemStyle.color = '#ffffff';
        this.deathsOptions.legend.itemHiddenStyle.color = '#000000';
        this.deathsOptions.legend.itemHoverStyle.color = '#dddddd';
        this.confirmedOptions.chart.backgroundColor = '#00232a';
        this.confirmedOptions.xAxis.labels.style.color = '#ffffff';
        this.confirmedOptions.yAxis.labels.style.color = '#ffffff';
        this.confirmedOptions.yAxis.title.style.color = '#ffffff';
        this.confirmedOptions.legend.itemStyle.color = '#ffffff';
        this.confirmedOptions.legend.itemHiddenStyle.color = '#000000';
        this.confirmedOptions.legend.itemHoverStyle.color = '#dddddd';
      }
      else {
        this.deathsOptions.chart.backgroundColor = '#ffffff';
        this.deathsOptions.xAxis.labels.style.color = '#000000';
        this.deathsOptions.yAxis.labels.style.color = '#000000';
        this.deathsOptions.yAxis.title.style.color = '#000000';
        this.deathsOptions.legend.itemStyle.color = '#000000';
        this.deathsOptions.legend.itemHiddenStyle.color = '#dddddd';
        this.deathsOptions.legend.itemHoverStyle.color = '#333333';
        this.confirmedOptions.chart.backgroundColor = '#ffffff';
        this.confirmedOptions.xAxis.labels.style.color = '#000000';
        this.confirmedOptions.yAxis.labels.style.color = '#000000';
        this.confirmedOptions.yAxis.title.style.color = '#000000';
        this.confirmedOptions.legend.itemStyle.color = '#000000';
        this.confirmedOptions.legend.itemHiddenStyle.color = '#dddddd';
        this.confirmedOptions.legend.itemHoverStyle.color = '#333333';
      }
    }
  }
}
</script>